import { Text, ScrollArea, Box } from "@mantine/core";
import { ProcessStep } from "../../services/logService";

export function NormalizationSetupContent({ log }: { log: ProcessStep }) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const details = (log.details as any) || {};
  const masters = Array.isArray(details.masters) ? details.masters : [];
  const patterns = Array.isArray(details.patterns) ? details.patterns : [];

  return (
    <Box mt={4}>
      <Text
        size="xs"
        c={log.status === "error" ? "red" : "inherit"}
        style={{ whiteSpace: "pre-line" }}
      >
        {log.description}
      </Text>

      {(masters.length > 0 || patterns.length > 0) && (
        <ScrollArea.Autosize mah={200} mt="xs" offsetScrollbars>
          {masters.length > 0 && (
            <Box mb="xs">
              <Text size="xs" fw={700} c="dimmed" mb={2}>
                マスタリスト ({masters.length}件)
              </Text>
              <Box pl={4}>
                {masters.map((m: string, i: number) => (
                  <Text key={i} size="xs" lh={1.5} style={{ wordBreak: "break-all" }}>
                    ・{m}
                  </Text>
                ))}
              </Box>
            </Box>
          )}

          {patterns.length > 0 && (
            <Box>
              <Text size="xs" fw={700} c="dimmed" mb={2}>
                学習済みパターン ({patterns.length}件)
              </Text>
              <Box pl={4}>
                {patterns.map((p: string, i: number) => (
                  <Text key={i} size="xs" lh={1.5} style={{ wordBreak: "break-all" }}>
                    ・{p}
                  </Text>
                ))}
              </Box>
            </Box>
          )}
        </ScrollArea.Autosize>
      )}
    </Box>
  );
}
